"use client";

import { TextLoader } from "generative-loaders";

/** The session status reveal, shared by real in-flight operations. */
export function WorkingText({
  children,
  active = false,
}: {
  children: string;
  active?: boolean;
}) {
  return active ? (
    <TextLoader
      text={children}
      variant="wipe"
      color="currentColor"
      className="mlx-live-update-text-loader"
    />
  ) : (
    <>{children}</>
  );
}
